import React from "react";
import { Route } from "react-router-dom";
import Protected from "../Protected";
import ComingSoonPage from "./ComingSoonPage";
import HomePage from "./pages/HomePage";
import { Navigate, useLocation } from "react-router-dom";
import SearchPage from "./pages/SearchPage";
import PublishPage from "./pages/PublishPage";
import MyloadsPage from "./pages/MyloadsPage";
import FleetPage from "./pages/FleetPage";
import CompaniesPage from "./pages/CompaniesPage";
import NotificationsPage from "./pages/NotificationsPage";
import SettingsPage from "./pages/SettingsPage";
import AddvehiclePage from "./pages/AddvehiclePage";
import EditvehiclePage from "./pages/EditvehiclePage";
import AnalyticsPage from "./pages/AnalyticsPage";

/** Old /loads and /transports links keep working: they open the unified search (query kept). */
function LegacySearch({ mode }) {
  const { search } = useLocation();
  const p = new URLSearchParams(search);
  p.set("mode", mode);
  return <Navigate to={`/search?${p.toString()}`} replace />;
}

const P = ({ children }) => <Protected>{children}</Protected>;

/** Wireframe-faithful cabinet (full-width shell). Replaces the old map-shell pages. */
export const cabinetRoutes = [
  <Route key="home" path="/" element={<P><HomePage /></P>} />,
  <Route key="search" path="/search" element={<P><SearchPage /></P>} />,
  <Route key="loads" path="/loads" element={<LegacySearch mode="loads" />} />,
  <Route key="transports" path="/transports" element={<LegacySearch mode="transport" />} />,
  <Route key="order" path="/order" element={<P><PublishPage /></P>} />,
  <Route key="my-orders" path="/my-orders" element={<P><MyloadsPage /></P>} />,
  <Route key="my-fleet" path="/my-fleet" element={<P><FleetPage /></P>} />,
  <Route key="fleet-add" path="/my-fleet/add" element={<P><AddvehiclePage /></P>} />,
  <Route key="fleet-edit" path="/my-fleet/:id/edit" element={<P><EditvehiclePage /></P>} />,
  <Route key="companies" path="/companies" element={<P><CompaniesPage /></P>} />,
  <Route key="notifications" path="/notifications" element={<P><NotificationsPage /></P>} />,
  <Route key="settings" path="/settings" element={<P><SettingsPage /></P>} />,
  <Route key="chats" path="/chats" element={<P><ComingSoonPage title="Чаты" /></P>} />,
  <Route key="analytics" path="/analytics" element={<P><AnalyticsPage /></P>} />,
  <Route key="payments" path="/payments" element={<P><ComingSoonPage title="Платежи" /></P>} />,
];
